import React from 'react';

const Footer: React.FC = () => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-darkest border-t border-mid py-14 px-10">
      <div className="max-w-[1260px] mx-auto grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-start gap-10">
        <div className="text-center md:text-left">
          <div className="flex flex-col leading-none gap-1">
            <span className="font-serif text-3xl font-bold tracking-[7px] text-white">
              GERAK
            </span>
            <span className="text-[9px] tracking-[3.5px] text-silver uppercase">
              Fashion & Classic
            </span>
          </div>
          <p className="text-xs text-silver leading-relaxed max-w-[280px] mt-4 mx-auto md:mx-0">
            L'élégance masculine réinventée. Des vêtements conçus pour l'homme moderne, exigeant et authentique.
          </p>
        </div>

        <div className="text-center">
          <div className="flex flex-col items-center gap-1 mb-5">
            <span className="font-serif text-2xl tracking-[5px] text-white">
              GERAK
            </span>
          </div>
          <div className="w-px h-10 bg-mid mx-auto mb-5"></div>
          <p className="text-[10px] text-mid tracking-[1.5px]">
            © 2025 GERAK — Tous droits réservés
          </p>
          <p className="text-[11px] text-mid italic tracking-[1px] mt-1.5">
            L'élégance masculine, sans compromis.
          </p>
        </div>

        <div className="text-center md:text-right">
          <nav className="flex flex-col gap-3.5 items-center md:items-end">
            {['hero', 'collections', 'univers', 'contact'].map(item => (
              <button
                key={item}
                onClick={() => scrollTo(item)}
                className="bg-none border-none text-[10px] tracking-[2px] uppercase text-silver transition-colors hover:text-white"
              >
                {item === 'hero' ? 'La Marque' : 
                 item === 'collections' ? 'Collections' :
                 item === 'univers' ? 'Notre Univers' : 'Contact'}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;